import { createIcon } from '@chakra-ui/icons';

export const WebcamRecording = createIcon({
  displayName: 'WebcamRecording',
  viewBox: '0 0 44 44',
  path: [
    <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_211_3483)">
        <path
          d="M1.40552 22C1.40552 37.6757 18.375 47.4731 31.9506 39.6352C38.251 35.9976 42.1323 29.2751 42.1323 22C42.1323 6.32422 25.1628 -3.47312 11.5872 4.36476C5.28676 8.00233 1.40552 14.7249 1.40552 22Z"
          fill="#FEF3DF"
        />
        <path
          d="M11.0742 37.6798C11.0742 38.3943 17.2621 38.8407 22.2125 38.4835C24.51 38.3178 25.9253 38.0114 25.9253 37.6798C25.9253 36.9654 19.7373 36.5189 14.787 36.8761C12.4895 37.0419 11.0742 37.3482 11.0742 37.6798Z"
          fill="#F1CA89"
        />
        <path
          d="M28.1749 21.5286C28.1749 28.9597 20.1306 33.6041 13.695 29.8885C7.25953 26.173 7.25953 16.8841 13.695 13.1686C15.1626 12.3213 16.827 11.8753 18.5217 11.8753C23.8532 11.875 28.1752 16.1971 28.1749 21.5286Z"
          fill="white"
        />
        <path
          d="M12.9522 21.5286C12.9484 25.8159 17.5872 28.4996 21.302 26.3592C23.0291 25.3641 24.0927 23.5219 24.0909 21.5286C24.0948 17.2413 19.456 14.5576 15.7411 16.698C14.014 17.6931 12.9504 19.5353 12.9522 21.5286Z"
          fill="white"
        />
        <path
          d="M14.8088 21.5286C14.8088 24.3867 17.9028 26.173 20.378 24.7439C21.5267 24.0807 22.2343 22.855 22.2343 21.5286C22.2343 18.6705 19.1404 16.8842 16.6652 18.3133C15.5165 18.9765 14.8088 20.2021 14.8088 21.5286Z"
          fill="#F1CA89"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.4105 37.0872C25.8831 37.0941 26.1858 36.5868 25.9555 36.1741L25.9537 36.1709C25.3579 35.3153 24.3987 34.7847 23.3574 34.7348H13.7209C12.6795 34.7847 11.7203 35.3153 11.1245 36.1709C10.8917 36.5822 11.1914 37.0913 11.664 37.0873L11.6677 37.0872H25.4105Z"
          fill="white"
        />
        <path
          d="M28.1749 21.5286C28.1749 28.9597 20.1306 33.6041 13.695 29.8885C7.25953 26.173 7.25953 16.8841 13.695 13.1686C15.1626 12.3213 16.827 11.8753 18.5217 11.8753C23.8532 11.875 28.1752 16.1971 28.1749 21.5286Z"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.8088 21.5286C14.8088 24.3867 17.9028 26.173 20.378 24.7439C21.5267 24.0807 22.2343 22.855 22.2343 21.5286C22.2343 18.6705 19.1404 16.8842 16.6652 18.3133C15.5165 18.9765 14.8088 20.2021 14.8088 21.5286Z"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9522 21.5286C12.9484 25.8159 17.5872 28.4996 21.302 26.3592C23.0291 25.3641 24.0927 23.5219 24.0909 21.5286C24.0948 17.2413 19.456 14.5576 15.7411 16.698C14.014 17.6931 12.9504 19.5353 12.9522 21.5286Z"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.7049 34.7358L20.0818 31.0566C19.5672 31.1501 19.0444 31.1921 18.5214 31.1818C18.019 31.1946 17.5167 31.1557 17.0222 31.0658L16.4011 34.7358H20.7049Z"
          fill="white"
        />
        <path
          d="M20.7049 34.7358L20.0818 31.0566C19.5672 31.1501 19.0444 31.1921 18.5214 31.1818C18.019 31.1946 17.5167 31.1557 17.0222 31.0658L16.4011 34.7358H20.7049Z"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.3758 37.0872C25.848 37.0948 26.1512 36.5883 25.9217 36.1757L25.919 36.1709C25.3232 35.3153 24.364 34.7847 23.3227 34.7348H13.6867C12.6453 34.7847 11.6861 35.3153 11.0904 36.1709C10.8575 36.5822 11.1572 37.0913 11.6299 37.0873L11.6341 37.0872H25.3758Z"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5216 11.8753C15.4012 11.8755 12.474 13.3867 10.667 15.9307C11.0971 17.0283 12.2299 17.9747 13.78 18.6187C15.9522 15.0639 21.1187 15.0747 23.276 18.6385C24.8262 18.0047 25.9655 17.07 26.4155 15.9836C24.612 13.4084 21.6656 11.8749 18.5216 11.8753Z"
          fill="#F1CA89"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.7822 13.9799C17.7822 14.5752 18.4267 14.9472 18.9422 14.6496C19.1815 14.5114 19.3288 14.2562 19.3288 13.9799C19.3288 13.3846 18.6844 13.0125 18.1689 13.3102C17.9296 13.4483 17.7822 13.7036 17.7822 13.9799Z"
          fill="white"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.1746 4.31543H42.6725C43.3164 4.31543 43.8383 4.83737 43.8383 5.48123V21.4634C43.8386 22.1066 43.3177 22.6284 42.6746 22.6292H23.1741C22.5305 22.6292 22.0088 22.1075 22.0088 21.464V5.48123C22.0088 4.83737 22.5307 4.31543 23.1746 4.31543Z"
          fill="#F1CA89"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.6745 4.31543H23.1765C22.533 4.31512 22.0112 4.83671 22.0112 5.48018V8.31833H43.8398V5.4807C43.8398 4.83715 43.318 4.31543 42.6745 4.31543Z"
          fill="white"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.5831 12.6511L34.9196 13.6184V12.5341C34.9196 12.0561 34.5321 11.6687 34.0541 11.6686H28.2658C27.7879 11.6687 27.4004 12.0561 27.4004 12.5341V17.603C27.4001 18.0826 27.7888 18.4715 28.2684 18.4715H34.0521C34.5311 18.4715 34.919 18.0825 34.9176 17.6035V16.5167L37.5811 17.4839C37.8037 17.5647 38.039 17.4 38.0393 17.1632V12.9694C38.0368 12.7348 37.804 12.5725 37.5831 12.6511Z"
          fill="white"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.7998 6.3166C23.7985 6.84176 24.3661 7.17138 24.8216 6.90998C25.034 6.78805 25.1648 6.56158 25.1642 6.3166C25.1655 5.79149 24.5978 5.46182 24.1424 5.72323C23.9299 5.8452 23.7992 6.07166 23.7998 6.3166Z"
          fill="white"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.6135 6.3166C26.6122 6.84176 27.1799 7.17138 27.6353 6.90998C27.8478 6.78805 27.9785 6.56158 27.9779 6.3166C27.9792 5.79149 27.4116 5.46182 26.9561 5.72323C26.7437 5.8452 26.6129 6.07166 26.6135 6.3166Z"
          fill="white"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.4021 6.3166C29.4008 6.84176 29.9684 7.17138 30.4238 6.90998C30.6363 6.78805 30.7671 6.56158 30.7664 6.3166C30.7678 5.79149 30.2001 5.46182 29.7447 5.72323C29.5322 5.8452 29.4015 6.07166 29.4021 6.3166Z"
          fill="white"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_211_3483">
          <rect width="44" height="44" fill="white" transform="translate(0.75)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
